import Vue from 'vue';

/**
 * Preenche sozinho o campo de selecao quando a lista tem uma unica opcao.
 *
 * Age so quando a lista muda: se o usuario limpar o campo de proposito, nao preenche de novo.
 * Seleciona pelo proprio componente (selectItem), entao o v-model e os @change do campo
 * disparam como se o usuario tivesse escolhido.
 *
 * Uso: <v-autocomplete v-auto-select-single ... /> ou num componente que embrulha um
 * v-select/v-autocomplete (ex.: CurrencySelect). v-auto-select-single="false" desliga.
 */

const STATE_KEY = '__autoSelectSingle';

function findSelect(vm) {
  if (!vm) return null;

  if (typeof vm.selectItem === 'function' && Array.isArray(vm.items)) return vm;

  for (const child of vm.$children || []) {
    const found = findSelect(child);

    if (found) return found;
  }

  return null;
}

function isEmpty(value) {
  if (value == null || value === '') return true;

  if (Array.isArray(value)) return value.length === 0;

  if (typeof value === 'object') return value.id == null && value.code == null && Object.values(value).every((v) => v == null || v === '');

  return false;
}

function signature(select) {
  return select.items.map((item) => {
    const value = select.getValue ? select.getValue(item) : item;

    return typeof value === 'object' ? JSON.stringify(value?.id ?? value) : String(value);
  }).join('|');
}

function apply(el, binding, vnode) {
  if (binding.value === false) return;

  Vue.nextTick(() => {
    const select = findSelect(vnode.componentInstance);

    if (!select) return;

    const state = el[STATE_KEY] || (el[STATE_KEY] = { lastSignature: null });
    const current = signature(select);

    if (current === state.lastSignature) return;

    state.lastSignature = current;

    if (select.items.length !== 1 || select.multiple) return;

    if (select.isDisabled || select.isReadonly) return;

    if (!isEmpty(select.internalValue)) return;

    select.selectItem(select.items[0]);
  });
}

export default {
  inserted: apply,
  componentUpdated: apply
};
